import React from "react";
import { Modal, InputNumber, Input, Form } from "antd";

const UseAddModal = ({ fields, ...props }) => {
  const [open, setOpen] = React.useState(false);
  const [form] = Form.useForm();
  const generate = (field) => {
    const Component = field.type === "number" ? InputNumber : Input;
    return (
      <Form.Item
        name={field.name}
        label={field.placeholder}
        rules={[{ required: true }]}
      >
        <Component />
      </Form.Item>
    );
  };

  const context = (
    <div>
      <Modal open={open} {...props} onCancel={() => setOpen(false)}>
        <Form form={form} layout={"vertical"}>
          {fields.map(generate)}
        </Form>
      </Modal>
    </div>
  );
  return {
    context,
    api: {
      getValues: () => form.getFieldsValue(),
      open: () => {
        console.log("trigger");
        setOpen(true);
      },
    },
  };
};

export default UseAddModal;
